import { render, staticRenderFns } from "./Pessoa.vue?vue&type=template&id=b6d7a436&scoped=true&"
import script from "./Pessoa.vue?vue&type=script&lang=js&"
export * from "./Pessoa.vue?vue&type=script&lang=js&"
import style0 from "./Pessoa.vue?vue&type=style&index=0&id=b6d7a436&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d7a436",
  null
  
)

export default component.exports